import React, { lazy, useContext } from "react";
import { Routes, Route } from "react-router-dom";
import { WebRoutes } from "../routes/WebRoutesPath";
import { privacy } from "../common/privacy-terms";
import AuthenticateUser from "../pages/AuthenticateUser";

import { getData } from "../common/strapiUrl";
import { useState } from "react";
import { useLayoutEffect } from "react";
import { TripContext } from "../context";
import PrivacyAndTerms from "../components/PrivacyAndTerms";
import ReservationForm from "../pages/reservationForm/ReservationForm";
import Inquire from "../pages/inquire/Inquire";

const CMSCompaonets = lazy(() => import("../components/CMSCompaonets"));
const Layout = lazy(() => import("./Layout"));
/* pages */
const Blog = lazy(() => import("../pages/blog"));
const Country = lazy(() => import("../pages/countries"));
const BrochureView = lazy(() => import("../pages/tripDetail/downloads/Brochure"));
const SpecialDetail = lazy(() => import("../pages/blog/SpecialDetail"));
const HomePage = lazy(() => import("../pages/home"));
const TripDetail = lazy(() => import("../pages/tripDetail"));
const TravelStylesPage = lazy(() => import("../pages/travelStyles"));
const Destinations = lazy(() => import("../pages/destinations"));
const LastMinuteDeals = lazy(() => import("../pages/lastMinuteDeals"));
const SoloTravel = lazy(() => import("../pages/soloTravel"));
const LoyaltyProgram = lazy(() =>
  import("../pages/footerPages/LoyaltyProgram")
);
const FAQ = lazy(() => import("../pages/footerPages/FAQ"));
const Contest = lazy(() => import("../pages/footerPages/Contest"));
const Privacy = lazy(() => import("../pages/footerPages/Privacy"));
const UserProfile = lazy(() => import("../pages/userProfile"));
const Testimonials = lazy(() => import("../pages/testimonials"));
const IndividualTripFilter = lazy(() =>
  import("../pages/IndividualTripFilter")
);
const SupplierInfo = lazy(() => import("../pages/supplierDetails"));
const TripmerchantJourneys = lazy(() =>
  import("../pages/tripMerchantJourneys")
);
const GroupDepartures = lazy(() => import("../pages/groupDepartures"));
const MembersBenefits = lazy(() => import("../pages/MembersBenefits"));
/* others */
const Error = lazy(() => import("../pages/Error"));
const WebNotFound = lazy(() => import("../pages/WebNotFound"));
/* comming soon */
const ComingSoon = lazy(() => import("../pages/ComingSoon"));

/* const Tips = lazy(() => import("../pages/travelInspirationPage/Tips"));
const Videos = lazy(() => import("../pages/travelInspirationPage/Videos"));
const OnlinePresentations = lazy(() =>
  import("../pages/footerPages/OnlinePresentations")
);
const Blog = lazy(() => import("../pages/blog"));;
; */

const WebUrlRoutes = () => {
  const { pages } = useContext(TripContext);
  // const [pages, setPages] = useState([]);
  // useLayoutEffect(() => {
  //   getData("/pages").then((res) => {
  //     setPages(res?.data);
  //     // console.log(res?.data, "res");
  //   });
  // }, []);

  return (
    <Routes>
      <Route path={"/verify"} element={<AuthenticateUser />} />
      <Route path={WebRoutes.WebNotFound} element={<WebNotFound />} />
      <Route path={"*"} element={<Error />} />
      <Route path={"/supplier-trip-detail/:id"} element={<TripDetail isSupplierMode={true}/>} />
      <Route element={<Layout />}>
        <Route exact path={WebRoutes.Home} element={<HomePage />} />
        <Route exact path={WebRoutes.TripDetail} element={<TripDetail />} />
        <Route exact path={`${WebRoutes.TripDetail}/brochure`} element={<BrochureView />} />
        <Route
          exact
          path={WebRoutes.TravelStyles}
          element={<TravelStylesPage />}
        />
        <Route exact path={WebRoutes.Destinations} element={<Destinations />} />
        {/* <Route exact path={WebRoutes.SoloTravel} element={<SoloTravel />} /> */}
        <Route exact path={WebRoutes.Search} element={<LastMinuteDeals />} />
        {/* <Route
          exact
          path={WebRoutes.LoyaltyProgram}
          element={<LoyaltyProgram />}
        /> */}
        {/* <Route
          exact
          path={WebRoutes.tmUpgrades}
          element={
            <LoyaltyProgram
              title={"Trip Merchant Premium Upgrades"}
              content="tmUpgrades"
            />
          }
        /> */}
        <Route exact path={WebRoutes.FAQ} element={<FAQ />} />{" "}
        <Route
          exact
          path={WebRoutes.reservationForm}
          element={<ReservationForm />}
        />{" "}
        <Route exact path={WebRoutes.UserProfile} element={<UserProfile />} />
        <Route exact path={WebRoutes.Privacy} element={<PrivacyAndTerms />} />
        <Route
          exact
          path={WebRoutes.Terms}
          element={<PrivacyAndTerms title={"Trip Merchant | Terms of use"} />}
        />
        <Route exact path={WebRoutes.testimonials} element={<Testimonials />} />
        {pages?.length > 0 &&
          pages?.map((item) => {
            return (
              <Route
                key={item?.id + item?.attributes?.url}
                exact
                path={item?.attributes?.url}
                element={
                  <CMSCompaonets
                    url={item?.attributes?.url}
                    title={item?.attributes?.Title}
                    blocks={item?.attributes?.blooks}
                  />
                }
              />
            );
          })}
        {/* <Route exact path={"/test"} element={<CMSCompaonets />} /> */}
        <Route
          exact
          path={WebRoutes.submitTestimonial}
          element={
            <Testimonials
              title={"Submit Testimonial"}
              form={true}
              bannerTitle={"Submit Testimonial"}
            />
          }
        />
        <Route
          exact
          path={WebRoutes.individual}
          element={<IndividualTripFilter />}
        />
        <Route
          exact
          path={`${WebRoutes.supplierInfo}/:id`}
          element={<SupplierInfo />}
        />
        {/* <Route
          exact
          path={WebRoutes.tripmerchantJourneys}
          element={<TripmerchantJourneys />}
        /> */}
        <Route
          exact
          path={WebRoutes.groupDepartures}
          element={<GroupDepartures />}
        />
        {/* coming soon pages */}
        {/* <Route
          exact
          path={WebRoutes.Contest}
          element={
            <Contest />
          // <ComingSoon title="Trip Contest" />
          }
        /> */}
        {/* <Route
          exact
          path={WebRoutes.OnlinePresentations}
          element={
             <ComingSoon title="Online Presentations" />
          }
        /> */}
        <Route
          exact
          path={WebRoutes.LastMinuteDeals}
          element={<LastMinuteDeals type={"deals"} />}
        />
        <Route exact path={WebRoutes.ALLCountries} element={<Country />} />

        {/* <ComingSoon title="Last Minute Deals" /> */}
        <Route exact path={WebRoutes.Tips} element={<Blog blogPage={true} />} />
        {/* <Route
          exact
          path={WebRoutes.videos}
          element={
          <ComingSoon title="Travel Inspiration Videos" />
          }
        /> */}
        {/* <Route
          exact
          path={WebRoutes.MemberExperience}
          element={ <ComingSoon title="Member Experiences" />}
        /> */}
        <Route
          exact
          path={WebRoutes.BlogbyId}
          element={<SpecialDetail /> /*<ComingSoon title="Blog" />*/}
          // element={/*<Blog />*/ <ComingSoon title="Blog" />}
        />
        <Route
          exact
          path={WebRoutes.inquire}
          element={<Inquire /> /*<ComingSoon title="Blog" />*/}
          // element={/*<Blog />*/ <ComingSoon title="Blog" />}
        />
        {/* <Route
          exact
          path={WebRoutes.membersBenefits}
          element={<MembersBenefits />} // <ComingSoon title="Member Benefits"/>
        /> */}
      </Route>
    </Routes>
  );
};

export default WebUrlRoutes;
